// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CategorySelect = registerClientReference(
    function() { throw new Error("Attempted to call CategorySelect() from the server but CategorySelect is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/category-select.tsx",
    "CategorySelect",
);
export const CategorySelectDrawerContent = registerClientReference(
    function() { throw new Error("Attempted to call CategorySelectDrawerContent() from the server but CategorySelectDrawerContent is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/category-select.tsx",
    "CategorySelectDrawerContent",
);
